var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dialog"},[_c('div',{staticClass:"content",style:({'width':_vm.width,'height':_vm.height})},[_c('div',{staticClass:"header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"el-icon-close",on:{"click":_vm.close}})]),_c('div',{staticClass:"body"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }